<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">User Activity Logs</h4>
            <div class="btn-group">
              <!-- Export Button -->
              <!-- <button class="btn bg-danger-custom me-2" (click)="exportToCSV()">
                <i class="feather icon-download"></i> Export CSV
              </button> -->
              <!-- Column Selector Dropdown -->
              <div class="dropdown">
                <!-- <button class="btn bg-danger-custom dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="feather icon-columns"></i> Columns
                </button>
                <ul class="dropdown-menu dropdown-menu-end" style="max-height: 400px; overflow-y: auto;">
                  <li *ngFor="let col of availableColumns">
                    <a class="dropdown-item" href="javascript:void(0)" (click)="toggleColumn(col)">
                      <input type="checkbox" [checked]="col.selected" class="form-check-input me-2">
                      {{ col.displayName }}
                    </a>
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
        <div class="card-body">
          <!-- Filter Accordion -->
          <ngb-accordion #acc="ngbAccordion" activeIds="filter-panel">
            <ngb-panel id="filter-panel" title="Filters">
              <ng-template ngbPanelContent>
                <form [formGroup]="filterForm" (ngSubmit)="applyFilters()">
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label for="user" class="form-label">User Email</label>
                      <input type="text" class="form-control" id="user" formControlName="user" placeholder="Enter username">
                    </div>
                    <div class="col-md-4">
                      <label for="category" class="form-label">Category</label>
                      <select class="form-select" id="category" formControlName="category">
                        <option value="">All Categories</option>
                        <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
                      </select>
                    </div>
                    <div class="col-md-4">
                      <label for="method" class="form-label">Method</label>
                      <select class="form-select" id="method" formControlName="method">
                        <option value="">All Methods</option>
                        <option *ngFor="let method of methods" [value]="method">{{ methodsMap[method] || method }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label for="startDate" class="form-label">Start Date</label>
                      <input type="datetime-local" class="form-control" id="startDate" formControlName="startDate">
                    </div>
                    <div class="col-md-4">
                      <label for="endDate" class="form-label">End Date</label>
                      <input type="datetime-local" class="form-control" id="endDate" formControlName="endDate">
                    </div>
                    <div class="col-sm-4 d-flex align-items-end">
                      <button type="submit" class="btn bg-danger-custom" style="width: 100%;">
                        <i class="feather icon-filter me-2"></i>Apply Filters
                      </button>
                      <button type="button" class="btn btn-secondary me-2" (click)="resetFilters()" style="width: 100%;">
                        <i class="feather icon-refresh-cw me-2"></i>Reset
                      </button>
                     
                    </div>
                  </div>
                </form>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>

          <!-- AG Grid Table -->
          <div class="ag-grid-container mt-4">
            <ag-grid-angular
              style="width: 100%; height: 500px;"
              class="ag-theme-alpine"
              [rowData]="rowData"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              [pagination]="false"
              [suppressPaginationPanel]="true"
              (gridReady)="onGridReady($event)"
              [overlayLoadingTemplate]="'<span class=\'ag-overlay-loading-center\'>Loading data...</span>'"
              [overlayNoRowsTemplate]="'<span class=\'ag-overlay-no-rows-center\'>No activity logs found</span>'"
            ></ag-grid-angular>
          </div>

          <!-- Custom Pagination -->
          <div class="row mt-3" *ngIf="collectionSize > 0">
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <label class="me-2">Page Size:</label>
                <select class="form-select form-select-sm" style="width: 80px;" [(ngModel)]="pageSize" (change)="onPageSizeChange(pageSize)">
                  <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
                </select>
                <span class="ms-3">Total: {{ collectionSize }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <ngb-pagination
                class="d-flex justify-content-end"
                [collectionSize]="collectionSize"
                [page]="currentPage + 1"
                [pageSize]="pageSize"
                [maxSize]="5"
                [rotate]="true"
                [boundaryLinks]="true"
                (pageChange)="onPageChange($event)"
              ></ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Enhanced Payload Modal with Menu Hierarchy -->
<div class="modal" [ngClass]="{'d-block': showPayloadModal, 'd-none': !showPayloadModal}" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Activity Details</h5>
        <button type="button" class="btn-close" (click)="closePayloadModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body" *ngIf="selectedActivity">
        <!-- Basic Information Row -->
        <div class="row mb-3">
          <div class="col-md-6">
            <p><strong>User:</strong> {{ selectedActivity.user }}</p>
            <p><strong>Timestamp:</strong> {{ selectedActivity.timestamp | date:'medium' }}</p>
            <p><strong>Method:</strong> <span class="badge bg-primary">{{ methodsMap[selectedActivity.method] || selectedActivity.method }}</span></p>
            <p><strong>Session ID:</strong> {{ selectedActivity.sessionId }}</p>
          </div>
          <div class="col-md-6">
            <p><strong>Category:</strong> {{ selectedActivity.category }}</p>
            <p><strong>Action:</strong> {{ selectedActivity.action }}</p>
            <p><strong>URL:</strong> <code>{{ selectedActivity.url }}</code></p>
            <p><strong>API Sequence:</strong> {{ selectedActivity.apiSequenceNumber || 'N/A' }}</p>
          </div>
        </div>

        <!-- Menu Hierarchy Card -->
        <div class="card mb-3 border-primary">
          <div class="card-header bg-primary text-white">
            <h6 class="mb-0"><i class="feather icon-navigation"></i> Menu Navigation Hierarchy</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <p><strong>Main Menu:</strong> <span class="badge bg-info">{{ selectedActivity.mainMenu || 'N/A' }}</span></p>
                <p><strong>Sub Menu:</strong> <span class="badge bg-info">{{ selectedActivity.subMenu || 'N/A' }}</span></p>
                <p><strong>Tab/Section:</strong> <span class="badge bg-info">{{ selectedActivity.tabMenu || 'N/A' }}</span></p>
                <p><strong>Form Section:</strong> <span class="badge bg-info">{{ selectedActivity.formSection || 'N/A' }}</span></p>
              </div>
              <div class="col-md-6">
                <p><strong>Menu Path:</strong> {{ selectedActivity.menuBreadcrumb || 'N/A' }}</p>
                <p><strong>Menu Depth:</strong> {{ selectedActivity.menuDepth || 0 }} levels</p>
                <div *ngIf="selectedActivity.isWizardStep">
                  <p><strong>Wizard Step:</strong> <span class="badge bg-success">{{ selectedActivity.wizardStepName }}</span></p>
                  <p><strong>Step Number:</strong> <span class="badge bg-warning">Step {{ selectedActivity.wizardStepNumber }}</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- PII Audit Information (if applicable) -->
        <div class="card mb-3 border-danger" *ngIf="selectedActivity.piiAuditType">
          <div class="card-header bg-danger text-white">
            <h6 class="mb-0"><i class="feather icon-shield"></i> PII Audit Information</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <p><strong>Audit Type:</strong> <span class="badge bg-danger">{{ selectedActivity.piiAuditType }}</span></p>
                <p><strong>Field Name:</strong> {{ selectedActivity.fieldName || 'N/A' }}</p>
                <p><strong>Target User ID:</strong> {{ selectedActivity.targetUserId || 'N/A' }}</p>
                <p><strong>Audit Reason:</strong> {{ selectedActivity.auditReasonDescription || 'N/A' }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Audit Comment:</strong> {{ selectedActivity.auditComment || 'N/A' }}</p>
                <p><strong>PII Context:</strong> {{ selectedActivity.piiContext || 'N/A' }}</p>
                <p><strong>Entity Type:</strong> {{ selectedActivity.entityType || 'N/A' }}</p>
                <p><strong>Operation:</strong> {{ selectedActivity.operationDescription || 'N/A' }}</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Device Information Card -->
        <div class="card mb-3">
          <div class="card-header bg-light">
            <h6 class="mb-0"><i class="feather icon-monitor"></i> Device Information</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <p><strong>Browser:</strong> {{ selectedActivity.browser }} {{ selectedActivity.browserVersion }}</p>
                <p><strong>OS:</strong> {{ selectedActivity.os }} {{ selectedActivity.osVersion }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Screen Resolution:</strong> {{ selectedActivity.screen_resolution }}</p>
                <p><strong>User Agent:</strong> <small>{{ selectedActivity.userAgent }}</small></p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Payload Card -->
        <div class="card mb-3">
          <div class="card-header bg-light">
            <h6 class="mb-0"><i class="feather icon-code"></i> Request Payload</h6>
          </div>
          <div class="card-body">
            <div *ngIf="selectedActivity.payload">
              <div *ngIf="selectedActivity.payload.body">
                <h6>Body:</h6>
                <pre class="bg-light p-3 rounded">{{ selectedActivity.payload.body | json }}</pre>
              </div>
              
              <div *ngIf="selectedActivity.payload.queryParams && (selectedActivity.payload.queryParams | json) !== '{}'">
                <h6>Query Parameters:</h6>
                <pre class="bg-light p-3 rounded">{{ selectedActivity.payload.queryParams | json }}</pre>
              </div>
              
              <div *ngIf="selectedActivity.payload.pathParams && selectedActivity.payload.pathParams.length > 0">
                <h6>Path Parameters:</h6>
                <pre class="bg-light p-3 rounded">{{ selectedActivity.payload.pathParams | json }}</pre>
              </div>
            </div>
            <div *ngIf="!selectedActivity.payload">
              <p class="text-muted">No payload data available</p>
            </div>
          </div>
        </div>
        
        <!-- Session Information Card -->
        <div class="card">
          <div class="card-header bg-light">
            <h6 class="mb-0"><i class="feather icon-clock"></i> Session Information</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <!-- <p><strong>Session Duration:</strong> {{ selectedActivity.sessionDuration ? formatDuration(selectedActivity.sessionDuration) : 'N/A' }}</p> -->
                <p><strong>Journey Start Time:</strong> {{ selectedActivity.journeyStartTime ? (selectedActivity.journeyStartTime | date:'medium') : 'N/A' }}</p>
               <!-- <p><strong>Time Since Last Call:</strong> {{ selectedActivity.timeSinceLastCall ? formatDuration(selectedActivity.timeSinceLastCall) : 'N/A' }}</p> -->
              </div>
              <div class="col-md-6">
                <!-- <p><strong>API Sequence Number:</strong> {{ selectedActivity.apiSequenceNumber || 'N/A' }}</p> -->
                <p><strong>Flow Type:</strong> {{ selectedActivity.flowType || 'N/A' }}</p>
             <!-- //   <p><strong>Business Domain:</strong> {{ selectedActivity.businessDomain || 'N/A' }}</p> -->
             <!-- //   <p><strong>Access Level:</strong> <span class="badge bg-secondary">{{ selectedActivity.accessLevel || 'N/A' }}</span></p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closePayloadModal()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade show" *ngIf="showPayloadModal"></div>